import { DialogBody }          from '@/components/ui/dialog'
import { DialogCloseTrigger }  from '@/components/ui/dialog'
import { DialogContent }       from '@/components/ui/dialog'
import { DialogHeader }        from '@/components/ui/dialog'
import { DialogRoot }          from '@/components/ui/dialog'
import { DialogTitle }         from '@/components/ui/dialog'
import { Dispatch }            from 'react'
import EmailForm               from '../forms/EmailForm'
import { SetStateAction }      from 'react'
import { useTranslation }      from 'react-i18next'

interface IEmailModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	onChangeEmailSuccess: (newEmail: string) => void;
}

const EmailModal = (props: IEmailModalProps) => {
	const { isOpen, setIsOpen, onChangeEmailSuccess } = props;
	const { t } = useTranslation();
	return (
		<DialogRoot open={isOpen} size={{ base: "xs", lg: "lg" }}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('pages.security.emailBox.actions.edit')}</DialogTitle>
				</DialogHeader>
				<DialogBody pb="4">
					<EmailForm setIsOpen={setIsOpen} onChangeEmailSuccess={onChangeEmailSuccess} />
				</DialogBody>
				<DialogCloseTrigger onClick={() => setIsOpen(false)} />
			</DialogContent>
		</DialogRoot>
	)
}

export default EmailModal